module.exports = __webpack_public_path__ + "src/styles/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/styles/favicon.ico
// module id = 238
// module chunks = 1